import styled, { css } from 'styled-components'
import { AI_GRADIENT, AI_TERTIARY_TEXT } from './aiEvaluationTokens'

export const BlockButtonRoot = styled.a<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 72px;
  cursor: pointer;
  text-decoration: none !important;
  font-family: 'PT Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: ${AI_TERTIARY_TEXT} !important;
  transition: color 0.15s ease;

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.5;
    `}
`

export const BlockButtonIconCircle = styled.span<{ $disabled?: boolean }>`
  height: 52px;
  width: 52px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  background: ${({ $disabled }) => ($disabled ? '#bfbfbf' : AI_GRADIENT)};
  box-shadow: ${({ $disabled }) =>
    $disabled ? 'none' : '0 4px 12px rgba(255, 93, 44, 0.28)'};
  transition: transform 0.18s ease, box-shadow 0.18s ease;

  svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
    color: #ffffff !important;
  }

  ${BlockButtonRoot}:hover:not([aria-disabled='true']) & {
    transform: translateY(-5px);
    box-shadow: 0 12px 28px rgba(255, 93, 44, 0.42);
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      transform: none;
      box-shadow: none;
    `}
`
